export const CONFIDENTIAL_RECIPIENT_LABEL = "Confidential";

export type RecipientInput = {
	recipientType: string | null | undefined;
	recipient?: string | null | undefined;
};

export type RecipientDisplayMode = "table" | "details";

export function getRecipient({
	recipient,
}: RecipientInput): string | undefined {
	return recipient === null || recipient === undefined || recipient === ""
		? undefined
		: recipient;
}

export function getRecipientDisplay(
	quote: RecipientInput,
	recipientDisplayMode: RecipientDisplayMode,
): { text: string; recipient?: string } | undefined {
	const recipient = getRecipient(quote);

	if (recipient !== undefined) {
		return { text: recipient, recipient };
	}

	if (
		recipientDisplayMode === "details" ||
		quote.recipientType === "CONFIDENTIAL_INTENTS"
	) {
		return { text: CONFIDENTIAL_RECIPIENT_LABEL };
	}

	return undefined;
}

export function getRecipientOrLabel(quote: RecipientInput): string {
	return (
		getRecipient(quote) ??
		(quote.recipientType === "CONFIDENTIAL_INTENTS"
			? CONFIDENTIAL_RECIPIENT_LABEL
			: "")
	);
}
